import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './routes-base';

/*
 * Public account pages behind e-mail links (ADR-0031). No session needed: the one-time token
 * in the URL is the credential; the API answers 404 for anything invalid, used or expired.
 */

const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/undangan/$token',
  component: lazyRouteComponent(() => import('./account/accept-invite-page'), 'AcceptInvitePage'),
});

const requestResetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  component: lazyRouteComponent(() => import('./account/reset-password-page'), 'RequestResetPage'),
});

const setPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password/$token',
  component: lazyRouteComponent(() => import('./account/reset-password-page'), 'SetPasswordPage'),
});

const verifyEmailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/verifikasi-email/$token',
  component: lazyRouteComponent(() => import('./account/verify-email-page'), 'VerifyEmailPage'),
});

const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/legal/terms',
  component: lazyRouteComponent(() => import('./account/verify-email-page'), 'TermsPage'),
});

/** Self-serve sign-up after Google (ADR-0040); needs the browser's Google sign-in attempt. */
const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/daftar',
  component: lazyRouteComponent(() => import('./account/sign-up-page'), 'SignUpPage'),
});

export const accountRoutes = [
  signUpRoute,
  acceptInviteRoute,
  requestResetRoute,
  setPasswordRoute,
  verifyEmailRoute,
  termsRoute,
];
